module.exports = __webpack_public_path__ + "media/mypage/images/service/service2-67a9a8cd7b4ba757fba40eb5ce3d5a7c.jpg";